export const numberOfCards = { startIndex: 0, endIndex: 4 };
